module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ29tcG9uZW50XzNfMSIgZGF0YS1uYW1lPSJDb21wb25lbnQgMyDigJMgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPHBhdGggaWQ9IlVuaW9uXzMiIGRhdGEtbmFtZT0iVW5pb24gMyIgZD0iTTEyLDE0LjE4MiwyLjE4MSwyNCwwLDIxLjgxNyw5LjgxOCwxMiwwLDIuMTgxLDIuMTgxLDAsMTIsOS44MTgsMjEuODE3LDAsMjQsMi4xODEsMTQuMTgyLDEyLDI0LDIxLjgxNywyMS44MTcsMjRaIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.svg
// module id = zaOT
// module chunks = 0